<div class="card card-custom">
  <div *ngIf="form.title" class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ form.title | titlecase }}</h3>
    </div>
  </div>
  <div style="height: 60vh !important" class="card-body">
    <formio
      [form]="form.schema"
      [submission]="form.input"
      [readOnly]="form.viewMode"
      (change)="handleInputChange($event.data)"
    ></formio>
  </div>
  <div class="card-footer d-flex justify-content-end">
    <button
      mat-raised-button
      cdkFocusInitial
      style="width: 100px !important"
      class="btn btn-sm btn-light"
      (click)="closeDialog($event)"
    >
      {{ 'GLOBAL.CANCEL' | translate }}
    </button>
    <button
      *ngIf="!form.viewMode"
      mat-raised-button
      style="width: 100px !important"
      class="btn btn-sm btn-primary ml-4"
      (click)="submit($event)"
    >
      {{ 'GLOBAL.SAVE' | translate }}
    </button>
  </div>
</div>
